import React, { useState } from 'react';
import classNames from 'classnames';
import RoundButton from '../../../../components/RoundButton';
import './styles.css';

const ApplyButton = ({ onClick, children, className, active, ...prop }) => {
  const [hovered, setHovered] = useState();
  return (
    <div
      className={classNames('Listview__Filters__ApplyButton__root', {
        [className]: className,
      })}
    >
      <RoundButton
        type="button"
        className={classNames('Listview__Filters__ApplyButton__button', {
          'Listview__Filters__ApplyButton__button--hovered': hovered || active,
        })}
        size="small"
        theme="outlineBlue"
        onClick={onClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        {...prop}
      >
        {children}
      </RoundButton>
    </div>
  );
};

export default ApplyButton;
